import { render, staticRenderFns } from "./amendSpecification.vue?vue&type=template&id=49e54c6d&scoped=true"
import script from "./amendSpecification.vue?vue&type=script&lang=js"
export * from "./amendSpecification.vue?vue&type=script&lang=js"
import style0 from "./amendSpecification.vue?vue&type=style&index=0&id=49e54c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e54c6d",
  null
  
)

export default component.exports